import MessageBox from "@/shared/sweetAlert2";

function traduzirErros(texto) {
    if (!texto || typeof texto !== "string") return texto;
    return texto
        .replace(/Passwords must have at least one non alphanumeric character\./gi, "A senha deve conter ao menos um caractere especial.")
        .replace(/Passwords must have at least one lowercase \('a'-'z'\)\./gi, "A senha deve conter ao menos uma letra minÃºscula.")
        .replace(/Passwords must have at least one uppercase \('A'-'Z'\)\./gi, "A senha deve conter ao menos uma letra maiÃºscula.")
        .replace(/Passwords must have at least one digit \('0'-'9'\)\./gi, "A senha deve conter ao menos um nÃºmero.")
        .replace(/Passwords must be at least (\d+) characters\./gi, "A senha deve ter ao menos $1 caracteres.");
}

export function extrairMensagemDeErro(error, mensagemPadrao = "Ocorreu um erro inesperado.") {
    if (typeof error === "string") return traduzirErros(error);
    if (!error.response) return "NÃ£o foi possÃ­vel falar com o servidor. Verifique sua conexÃ£o e tente de novo.";

    const dados = error.response.data;
    let mensagem = "";

    if (typeof dados === "string" && dados.trim()) {
        mensagem = dados;
    } else if (dados && dados.mensagem) {
        mensagem = dados.mensagem;
    } else if (dados && dados.errors) {
        mensagem = Object.values(dados.errors).flat().join(" ");
    } else {
        mensagem = mensagemPadrao;
    }

    return traduzirErros(mensagem) || mensagemPadrao;
}

export function tratarErro(error, mensagemPadrao = "Ocorreu um erro inesperado.") {
    let formattedErrors = "";
    if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        for (const key in errors) {
            if (Object.prototype.hasOwnProperty.call(errors, key)) {
                formattedErrors += `${errors[key].join(", ")}\n`;
            }
        }
    } else if (error.response && error.response.data && error.response.data.mensagem) {
        formattedErrors = `${error.response.data.mensagem}`;
    } else {
        formattedErrors = mensagemPadrao;
    }
    MessageBox.error(traduzirErros(formattedErrors), "Oops");
}

